import React from 'react';
import { Skeleton } from '@chakra-ui/react';

export const TransactionLoader = () => {
	return (
		<Skeleton
			color="#828282"
			opacity="0.1"
			borderRadius="4px"
			width="90%"
			h="38px"
		/>
	);
};
